<template>
  <v-select
    ref="select"
    :value="value"
    @input="$emit('input', $event)"
    :rules="required ? [v => !!v || $t('rules.subscription')] : []"
    type="text"
    :label="$t('label.subscription')"
    :items="getAvailableSubscriptions"
    item-value="uuid"
    validate-on-blur
    :required="required"
    :class="'subscription-select ' + $attrs.class"
  >
    <!-- dropdown items -->
    <template #item="{ item }">
      <span v-if="item.placeholder">
        {{ $t("label.no_subscription") }}
      </span>
      <span v-else>
        {{ item.name }} -
        <span class="text-decoration-line-through" v-if="hasPromotion(item)">
          {{ (item.product_price_in_cents / 100) | currency }}
        </span>
        {{ hasPromotion(item) ? promoPrice(item) : regularPrice(item) }}
      </span>
    </template>

    <!-- selected value -->
    <template #selection="{ item }">
      <span v-if="item.placeholder">
        {{ $t("label.no_subscription") }}
      </span>
      <span v-else>
        {{ item.name }} -
        <span class="text-decoration-line-through" v-if="hasPromotion(item)">
          {{ (item.product_price_in_cents / 100) | currency }}
        </span>
        {{ hasPromotion(item) ? promoPrice(item) : regularPrice(item) }}
      </span>
    </template>

    <template #label>
      <span v-if="required" class="red--text"><strong>* </strong></span>
      {{ $t("label.subscription") }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: "AvailableSubscriptionsSelect",
  props: {
    value: { type: String, default: () => null },
    required: { type: Boolean, default: false },
    showDiscountPrice: { type: Boolean, default: false }
  },
  computed: {
    getAvailableSubscriptions() {
      const availableSubscriptions = this.$store.getters[
        "config/getAvailableSubscriptions"
      ];
      if (!this.required) {
        return [{ placeholder: true, uuid: null }, ...availableSubscriptions];
      }
      return availableSubscriptions;
    }
  },
  watch: {
    getAvailableSubscriptions: {
      immediate: true,
      handler(subscriptions) {
        if (
          Array.isArray(subscriptions) &&
          subscriptions.length === 1 &&
          !this.value
        ) {
          this.$emit("input", subscriptions[0].uuid);
          this.$nextTick(() => {
            this.$refs.select && this.$refs.select.validate();
          });
        }
      }
    }
  },
  methods: {
    hasPromotion(item) {
      return (
        this.showDiscountPrice &&
        !!(
          item &&
          item.promotion_duration_in_payment_cycles !== null &&
          item.promotion_duration_in_payment_cycles !== undefined &&
          item.promotion_price_in_cents !== null &&
          item.promotion_price_in_cents !== undefined
        )
      );
    },
    regularPrice(item) {
      return this.$t("label.price_per_subscription_duration", {
        price: this.$options.filters.currency(
          item.product_price_in_cents / 100
        ),
        duration: this.$options.filters.subscription_duration(
          item.payment_cycle
        )
      });
    },
    promoPrice(item) {
      return this.$t("label.price_per_subscription_duration", {
        price: this.$options.filters.currency(
          item.promotion_price_in_cents / 100
        ),
        duration: this.$options.filters.subscription_duration(
          item.payment_cycle
        )
      });
    }
  }
};
</script>
